module.exports = __webpack_public_path__ + "static/media/chicken-transparent.17e5c88f.png";